export const defaultUrlGetToken = 'api/v1/user/id-token';